import * as React from "react"
export const Svg_048 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={58}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M29.5 31.689c1.111 0 2.012-.886 2.012-1.978s-.901-1.977-2.012-1.977-2.012.885-2.012 1.977.9 1.978 2.012 1.978Z"
      />
      <path
        fill="url(#c)"
        d="M56.12 54.602V31.689h-8.341v22.913h-3.457V18.125h3.662v-3.398H31.228v-7.02h7.812V0H27.772v14.727H11.015v3.398h3.662v36.477h-3.457V31.689h-8.34v22.913H0V58h59v-3.398h-2.88ZM29.5 24.335c3.016 0 5.469 2.412 5.469 5.376 0 2.965-2.453 5.376-5.469 5.376-3.015 0-5.469-2.412-5.469-5.376 0-2.964 2.454-5.376 5.469-5.376Zm-6.045 24.779c0-3.277 2.712-5.943 6.045-5.943 3.333 0 6.045 2.666 6.045 5.943v5.488h-3.457v-5.488c0-1.403-1.161-2.544-2.588-2.544s-2.588 1.14-2.588 2.544v5.488h-3.457v-5.488Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={28.419}
        x2={30.283}
        y1={28.327}
        y2={31.396}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.644}
        x2={40.981}
        y1={8.7}
        y2={53.706}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v58H0z" />
      </clipPath>
    </defs>
  </svg>
)